import { missingWidget } from '../../utils/helpers';
import mainSlideshow from './2D-mainSlideshow';

// vimeo static api
const VIMEO_API_URL = 'https://player.vimeo.com/api/player.js';

// alternative fallback widget
const useAlternativeFallbackWidget = true;

export default function vimeoFeature() {
  const widgetName = 'vimeoFeature';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof vimeoFeatureOpts === 'undefined' ? null : vimeoFeatureOpts;

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  // Video Settings
  const videoSettings = {
    autoplay: true,
    controls: false,
    loop: true,
    muted: false,
  };

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createVimeoFeature(data.items[0]);
      } else {
        $widget.remove();
        mainSlideshow();
      }
    },
  });

  function createVimeoFeature(slide) {
    $widget.find('.card-widget-title, .buttonwrap').remove();
    const $source = $('<div>').html(slide.Description);
    const rawVimeoUrl = $source.find('iframe').attr('src');
    const finalUrl = rawVimeoUrl ? safeUrl(rawVimeoUrl, 'player.vimeo.com') : '#';

    if (finalUrl === '#') {
      return abortWidget(`Security Block: Unsafe or missing protocol in ${widgetName}.`);
    }

    const $description = $widget.find('.card-widget-description');
    $description.empty();

    const $sourceWrapper = $source.find('div').first();
    const wrapperStyle = $sourceWrapper.attr('style');

    const $wrapper = $('<div>', {
      style: wrapperStyle,
    });

    const $iframe = $('<iframe>', {
      src: `${finalUrl}${updateAutoplay(videoSettings)}`,
      frameborder: '0',
      allow:
        'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share',
      referrerpolicy: 'strict-origin-when-cross-origin',
      style: 'position:absolute;top:0;left:0;width:100%;height:100%;',
      title: 'Homepage video',
    });

    $wrapper.append($iframe);
    $description.append($wrapper);
    addVimeoApi();
    return true;
  }

  // --------------------
  // Abort widget due to security issue
  function abortWidget(reason) {
    console.warn(reason);
    $widget.remove();
    if (useAlternativeFallbackWidget) {
      mainSlideshow();
    } else {
      $('.main-feature-container').remove();
    }
    return false;
  }
}

// --------------------
// controls logic
function updateAutoplay(videoSettings) {
  const { controls, autoplay, loop, muted } = videoSettings;
  const videoControls = autoplay ? controls : true;

  return [
    `&controls=${videoControls ? 1 : 0}`,
    `&autoplay=${autoplay ? 1 : 0}`,
    `&loop=${loop ? 1 : 0}`,
    `&muted=${autoplay || muted ? 1 : 0}`,
  ].join('');
}

// --------------------
// vimeo api append
function addVimeoApi() {
  if (!$(`head script[src="${VIMEO_API_URL}"]`).length) {
    $('<script>', {
      src: VIMEO_API_URL,
    }).appendTo('head');
  }
}

// --------------------
// sanity check
function safeUrl(raw, allowedHost = null) {
  try {
    const u = new URL(raw, window.location.origin);

    if (u.protocol !== 'https:' && u.protocol !== 'http:') {
      return '#';
    }

    if (allowedHost && u.hostname !== allowedHost) {
      return '#';
    }

    return u.href;
  } catch {
    return '#';
  }
}
